module.exports = __webpack_public_path__ + "static/media/landImg.637ceee2.png";